import React, {useEffect, useState} from 'react';
import {useFieldArray, useForm} from "react-hook-form";
import {ToastContainer} from "react-toastify";
import axiosConfig from "./utils/axiosConfig";
import 'react-toastify/dist/ReactToastify.css';
import {fetchCountries, notify} from "./utils/utils";
import ReCAPTCHA from 'react-google-recaptcha';
import HeaderSubPageTiny from "./partial/HeaderSubPageTiny";
import axios from "axios";

const InviteFriend = ({partner}) => {
    const {
        register,
        control,
        handleSubmit,
        reset,
        trigger,
        formState: {errors}
    } = useForm({
        defaultValues: {
            agencyNo: partner?.agency_no,
            customerNo: '',
            friends: [{
                title: '',
                gender: '',
                email: '',
                firstname: '',
                lastname: '',
                street: '',
                houseNo: '',
                postalCode: '',
                city: '',
                country: 'DE'
            }]
        }
    });

    const {fields, append, remove} = useFieldArray({control, name: "friends"});

    const [isLoading, setIsLoading] = useState(false);
    const [countries, setCountries] = useState([]);
    const reCaptchaRef = React.createRef();

    const sendEmail = async (data) => {
        try {
            await axiosConfig.post('/newsletter/friend_referrals', data, {'Content-Type': 'application/json'});
            reset();
            notify("Vielen Dank für Ihre Empfehlung!", "success");
        } catch (error) {
            if (axios.isAxiosError(error)) {
                if (error.response?.status === 404) {
                    notify("Kundennummer wurde nicht gefunden. Bitte stellen Sie sicher, dass Sie die richtige Kundennummer eingegeben haben. Diese finden Sie auf der PDF-Rechnung."); // custom message
                } else {
                    notify(`Fehler: ${error.response?.status} ${error.response?.statusText}`);
                }
            } else {
                console.error("Unexpected error:", error);
            }
        } finally {
            setIsLoading(false);
        }
    }

    const onSubmit = async (data, event) => {
        event.preventDefault();
        setIsLoading(true);
        const captchaValue = await reCaptchaRef.current.executeAsync();
        if (!captchaValue) {
            notify("Bitte versuchen Sie es erneut!");
            setIsLoading(false);
            return;
        }
        data.reCaptchaToken = captchaValue;

        trigger().then(check => {
            if (check) sendEmail(data);
        });
    }

    useEffect(() => {
        document.title = `Freunde werben Freunde`;
        fetchCountries().then(setCountries);
    }, [partner]);

    return (
        <div>
            <ToastContainer/>
            <div className="site wrapper-content">
                <HeaderSubPageTiny title={'Freunde werben Freunde'}/>
                {partner?.agency_no ? (
                    <section className="content-area">
                        <div className="container">
                            <div className="row">
                                <div className="site-main col-lg-12 col-sm-12 aligncenter">
                                    <div className="pages_content">
                                        <h1 className="post_list_title">
                                            <span><strong>Freunde werben Freunde</strong></span>
                                        </h1>
                                        <div className="contact_infor">
                                            <p>
                                                <strong>Sie sind bereits Kunde bei globalis.de?</strong><br/>
                                                Dann teilen Sie Ihre Reiselust ganz unkompliziert über unser Formular!
                                                Für jeden Freund, der noch kein Kunde ist und über Ihre Empfehlung
                                                bucht,
                                                bedanken wir uns mit einer Prämie: Sie erhalten einen 25 €
                                                Reisegutschein.
                                                <br/>
                                                Auch Ihre Freunde profitieren – von unseren attraktiven Angeboten und
                                                einem <b>exklusiven Neukundenrabatt</b>.
                                            </p>
                                            <hr/>
                                        </div>
                                        <div className="row g-5">
                                            <h2 className="text-center mb-3">Und so funktioniert’s:</h2>
                                            <div className="col-md-4 text-center">
                                                <div className="mb-3 invite-friend">
                                                    <i className="fa fa-users fa-4x mb-3"></i>
                                                </div>
                                                <h3 className="h4">Weiterempfehlung</h3>
                                                <p>Füllen Sie das Formular mit den Adressen Ihrer Freunde aus und
                                                    klicken
                                                    Sie auf <strong>Absenden</strong>.</p>
                                            </div>
                                            <div className="col-md-4 text-center">
                                                <div className="mb-3 invite-friend">
                                                    <i className="fa fa-percent fa-4x mb-3"></i>
                                                </div>
                                                <h3 className="h4">Neukunde werden</h3>
                                                <p>Ihre Freunde erhalten nach Prüfung einen Prospekt und einen <strong>exklusiven
                                                    Neukundenrabatt.</strong></p>
                                            </div>
                                            <div className="col-md-4 text-center">
                                                <div className="mb-3 invite-friend">
                                                    <i className="fa fa-gift fa-4x mb-3"></i>
                                                </div>
                                                <h3 className="h4">Prämie erhalten</h3>
                                                <p>Nach der ersten Buchung Ihres Freundes erhalten Sie automatisch einen
                                                    25
                                                    € <strong>Reisegutschein</strong>.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <div className="site-main col-lg-8 col-sm-12 aligncenter">
                                    <div className="my-5">
                                        <div className="row mt-5">
                                            <div className="col">
                                                <div className="alert alert-info d-flex align-items-center">
                                                    <div className="d-flex flex-column">
                                                        <p className="p-wrap">
                                                            Bitte beachten Sie, dass uns die Adresse der geworbenen
                                                            Freunde
                                                            nicht bekannt sein darf. Pro Haushalt darf nur eine Person
                                                            geworben werden.
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <form onSubmit={handleSubmit(onSubmit)} noValidate>
                                        <input
                                            type="hidden"
                                            {...register("agencyNo")}
                                            defaultValue={partner.agency_no}
                                        />

                                        <div className="row">
                                            <div className="col-md-12 mb-3">
                                                <label>Kundennummer* (diese finden Sie auf Ihrer
                                                    PDF-Rechnung)</label>
                                                <input type="email"
                                                       className="form-control"  {...register(`customerNo`, {required: true})} />
                                                {errors?.customerNo &&
                                                    <p className="error">Kundennummer ist ein Pflichtfeld</p>}
                                            </div>
                                            <h3>
                                                Ich empfehle folgende Adresse(n):
                                            </h3>
                                        </div>


                                        {fields.map((friend, index) => (
                                            <div key={friend.id} className="friend-form mb-4 p-3 border rounded">
                                                {fields.length > 1 && (
                                                    <div className="text-end mt-2">
                                                        <a href="#!" onClick={() => remove(index)}
                                                           className="text-danger">
                                                            <i className="fa fa-trash me-1"></i> entfernen
                                                        </a>
                                                    </div>
                                                )}
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <label>Title</label>
                                                        <input
                                                            className="form-control" {...register(`friends.${index}.title`)} />
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Anrede*</label>
                                                        <select
                                                            className="form-control" {...register(`friends.${index}.gender`, {required: true})}>
                                                            <option value="">Bitte wählen</option>
                                                            <option value="Frau">Frau</option>
                                                            <option value="Herr">Herr</option>
                                                        </select>
                                                        {errors?.friends?.[index]?.gender &&
                                                            <p className="error">Anrede erforderlich</p>}
                                                    </div>
                                                </div>

                                                <div className="row mt-2">
                                                    <div className="col-md-6">
                                                        <label>Vorname*</label>
                                                        <input
                                                            className="form-control" {...register(`friends.${index}.firstname`, {required: true})} />
                                                        {errors?.friends?.[index]?.firstname &&
                                                            <p className="error">Pflichtfeld</p>}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Nachname*</label>
                                                        <input
                                                            className="form-control" {...register(`friends.${index}.lastname`, {required: true})} />
                                                        {errors?.friends?.[index]?.lastname &&
                                                            <p className="error">Pflichtfeld</p>}
                                                    </div>
                                                </div>

                                                <div className="row mt-2">
                                                    <div className="col-md-6">
                                                        <label>Email*</label>
                                                        <input type="email"
                                                               className="form-control" {...register(`friends.${index}.email`, {
                                                            required: true,
                                                            pattern: {
                                                                value: /\S+@\S+\.\S+/,
                                                                message: "Ungültige E-Mail"
                                                            }
                                                        })} />
                                                        {errors?.friends?.[index]?.email &&
                                                            <p className="error">{errors.friends[index].email?.message || "Pflichtfeld"}</p>}
                                                    </div>
                                                    <div className="col-md-6">
                                                        <label>Straße*</label>
                                                        <input
                                                            className="form-control" {...register(`friends.${index}.street`, {required: true})} />
                                                        {errors?.friends?.[index]?.street &&
                                                            <p className="error">Pflichtfeld</p>}
                                                    </div>
                                                </div>

                                                <div className="row mt-2">
                                                    <div className="col-md-4">
                                                        <label>Hausnummer*</label>
                                                        <input
                                                            className="form-control" {...register(`friends.${index}.houseNo`, {required: true})} />
                                                        {errors?.friends?.[index]?.houseNo &&
                                                            <p className="error">Pflichtfeld</p>}
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>PLZ*</label>
                                                        <input
                                                            className="form-control" {...register(`friends.${index}.postalCode`, {required: true})} />
                                                        {errors?.friends?.[index]?.postalCode &&
                                                            <p className="error">Pflichtfeld</p>}
                                                    </div>
                                                    <div className="col-md-4">
                                                        <label>Ort*</label>
                                                        <input
                                                            className="form-control" {...register(`friends.${index}.city`, {required: true})} />
                                                        {errors?.friends?.[index]?.city &&
                                                            <p className="error">Pflichtfeld</p>}
                                                    </div>
                                                </div>

                                                <div className="row mt-2">
                                                    <div className="col-md-12">
                                                        <label>Land*</label>
                                                        <select
                                                            className="form-control" {...register(`friends.${index}.country`, {required: true})}>
                                                            <option value="">Bitte wählen</option>
                                                            {countries.map((c, i) => <option key={i}
                                                                                             value={c.Kuerzel}>{c.Land}</option>)}
                                                        </select>
                                                        {errors?.friends?.[index]?.country &&
                                                            <p className="error">Pflichtfeld</p>}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}

                                        <button type="button" className="btn btn-secondary mb-3" onClick={() => append({
                                            title: '',
                                            gender: '',
                                            email: '',
                                            firstname: '',
                                            lastname: '',
                                            street: '',
                                            houseNo: '',
                                            postalCode: '',
                                            city: '',
                                            country: 'DE'
                                        })}>
                                            Weitere Empfehlung hinzufügen
                                        </button>

                                        <div className="form-check mb-3">
                                            <input type="checkbox"
                                                   className="form-check-input" {...register("accept", {required: true})} />
                                            <label className="form-check-label" htmlFor="defaultCheck1">
                                                Ja, ich willige ein, dass die GLOBALIS Erlebnisreisen GmbH meine
                                                Empfehlung
                                                nutzt, um meinen Anspruch auf eine Prämie zu prüfen sowie den Geworbenen
                                                einen Prospekt und weitere Angebote zuzusenden. Außerdem darf im
                                                Begleitschreiben an die geworbenen Personen darauf hingewiesen werden,
                                                dass
                                                die Empfehlung von mir stammt. Weitere Informationen in den <a
                                                href="/datenschutz" target="_blank">Datenschutzhinweisen</a>.
                                            </label>
                                            {errors.accept && <p className="error">Zustimmung erforderlich</p>}
                                        </div>

                                        <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                            {isLoading ? <i className="fa fa-spinner fa-spin"></i> : "Absenden"}
                                        </button>

                                        <ReCAPTCHA ref={reCaptchaRef} sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                                                   size="invisible"/>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <div className="d-flex justify-content-center align-items-center" style={{minHeight: "60vh"}}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}

export default InviteFriend;
